//! https://developer.spotify.com/documentation/web-api/reference/get-recommendations
//! to add min and max for energy, valence, danceability, etc

// const allGenres = [
//   'acoustic',
//   'afrobeat',
//   'alt-rock',
//   'alternative',
//   'ambient',
//   'anime',
//   'black-metal',
//   'bluegrass',
//   'blues',
//   'bossanova',
//   'brazil',
//   'breakbeat',
//   'british',
//   'cantopop',
//   'chicago-house',
//   'children',
//   'chill',
//   'classical',
//   'club',
//   'comedy',
//   'country',
//   'dance',
//   'dancehall',
//   'death-metal',
//   'deep-house',
//   'detroit-techno',
//   'disco',
//   'disney',
//   'drum-and-bass',
//   'dub',
//   'dubstep',
//   'edm',
//   'electro',
//   'electronic',
//   'emo',
//   'folk',
//   'forro',
//   'french',
//   'funk',
//   'garage',
//   'german',
//   'gospel',
//   'goth',
//   'grindcore',
//   'groove',
//   'grunge',
//   'guitar',
//   'happy',
//   'hard-rock',
//   'hardcore',
//   'hardstyle',
//   'heavy-metal',
//   'hip-hop',
//   'holidays',
//   'honky-tonk',
//   'house',
//   'idm',
//   'indian',
//   'indie',
//   'indie-pop',
//   'industrial',
//   'iranian',
//   'j-dance',
//   'j-idol',
//   'j-pop',
//   'j-rock',
//   'jazz',
//   'k-pop',
//   'kids',
//   'latin',
//   'latino',
//   'malay',
//   'mandopop',
//   'metal',
//   'metal-misc',
//   'metalcore',
//   'minimal-techno',
//   'movies',
//   'mpb',
//   'new-age',
//   'new-release',
//   'opera',
//   'pagode',
//   'party',
//   'philippines-opm',
//   'piano',
//   'pop',
//   'pop-film',
//   'post-dubstep',
//   'power-pop',
//   'progressive-house',
//   'psych-rock',
//   'punk',
//   'punk-rock',
//   'r-n-b',
//   'rainy-day',
//   'reggae',
//   'reggaeton',
//   'road-trip',
//   'rock',
//   'rock-n-roll',
//   'rockabilly',
//   'romance',
//   'sad',
//   'salsa',
//   'samba',
//   'sertanejo',
//   'show-tunes',
//   'singer-songwriter',
//   'ska',
//   'sleep',
//   'songwriter',
//   'soul',
//   'soundtracks',
//   'spanish',
//   'study',
//   'summer',
//   'swedish',
//   'synth-pop',
//   'tango',
//   'techno',
//   'trance',
//   'trip-hop',
//   'turkish',
//   'work-out',
//   'world-music'
// ]

export const moodsData = [
  {
    mood: 'Happy',
    target_valence: [0.7, 1],
    target_energy: [0.6, 0.9],
    seed_genres: ['pop', 'folk', 'reggae', 'funk']
  },
  {
    mood: 'Sad',
    target_valence: [0.0, 0.3],
    target_energy: [0.2, 0.4],
    seed_genres: ['blues', 'indie', 'r-n-b', 'soul', 'rainy-day']
  },
  {
    mood: 'Chill',
    target_valence: [0.4, 0.7],
    target_energy: [0.2, 0.5],
    seed_genres: ['ambient', 'chill', 'jazz', 'acoustic', 'study']
  },
  {
    mood: 'Excited',
    target_valence: [0.5, 0.8],
    target_energy: [0.7, 1],
    seed_genres: [
      'punk',
      'hip-hop',
      'dance',
      'edm',
      'work-out',
    ]
  },
  {
    mood: 'Amorous',
    target_valence: [0.5, 0.9],
    target_energy: [0.3, 0.6],
    seed_genres: ['r-n-b', 'soul', 'pop', 'indie', 'acoustic']
  },
  {
    mood: 'Melancholic',
    target_valence: [0, 0.4],
    target_energy: [0.2, 0.4],
    seed_genres: ['folk', 'indie', 'alternative', 'classical']
  },
  {
    mood: 'Angry',
    target_valence: [0, 0.2],
    target_energy: [0.8, 1],
    seed_genres: ['metal', 'punk', 'rock', 'hip-hop']
  },
  {
    mood: 'Motivational',
    target_valence: [0.7, 1],
    target_energy: [0.7, 1],
    seed_genres: ['pop', 'rock', 'hip-hop', 'edm']
  },
  {
    mood: 'Dreamy',
    target_valence: [0.4, 0.8],
    target_energy: [0.2, 0.5],
    seed_genres: ['dream pop', 'ambient', 'shoegaze']
  },
  // {
  //   mood: 'Nostalgic',
  //   target_valence: [0.5, 0.8],
  //   target_energy: [0.3, 0.6],
  //   seed_genres: ['80s', '90s', 'vintage', 'acoustic']
  // },
  // {
  //   mood: 'Adventure',
  //   target_valence: [0.5, 0.8],
  //   target_energy: [0.6, 0.9],
  //   seed_genres: ['indie', 'rock', 'soundtracks']
  // },
  // {
  //   mood: 'Dark',
  //   target_valence: [0, 0.3],
  //   target_energy: [0.4, 0.7],
  //   seed_genres: ['goth', 'darkwave', 'industrial', 'alternative']
  // },
  // {
  //   mood: 'Surreal',
  //   target_valence: [0.4, 0.7],
  //   target_energy: [0.3, 0.6],
  //   seed_genres: ['experimental', 'idm', 'ambient']
  // },
  {
    mood: 'Peaceful',
    target_valence: [0.4, 0.8],
    target_energy: [0.1, 0.3],
    seed_genres: [
      'classical',
      'new age',
      'ambient',
      'world',
      'sleep',
      'chill',
      'indie'
    ]
  }
  // {
  //   mood: 'Hypnotic',
  //   target_valence: [0.4, 0.7],
  //   target_energy: [0.4, 0.7],
  //   seed_genres: ['techno', 'trance', 'sleep']
  // },
  // {
  //   mood: 'Spiritual',
  //   target_valence: [0.6, 0.9],
  //   target_energy: [0.2, 0.5],
  //   seed_genres: ['gospel', 'world-music']
  // }
]
